// eslint-disable-next-line consistent-return,func-names
export default function ({ $auth, redirect, localePath }) {
  if ($auth.loggedIn && $auth.user.role !== 'admin') {
    return redirect(localePath({ name: 't-tenantSlug-m', params: { tenantSlug: $auth.user.workspace.slug } }));
  }
}
